"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationActions = void 0;
/*
    This component was originally based off of the PaginationActions implementation in
    https://github.com/marmelab/react-admin
*/
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var styles_1 = require("@material-ui/core/styles");
var ChevronLeft_1 = __importDefault(require("@material-ui/icons/ChevronLeft"));
var ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        offScreen: {
            position: "absolute",
            left: "-10000px",
            top: "auto",
            overflow: "hidden",
        },
        actions: {
            flexShrink: 0,
            color: theme.palette.text.secondary,
            marginLeft: 20,
        },
        hellip: { padding: "1.2em" },
    });
});
exports.PaginationActions = function (props) {
    var page = props.page, rowsPerPage = props.rowsPerPage, count = props.count, onChangePage = props.onChangePage, _a = props.showEndPages, showEndPages = _a === void 0 ? true : _a;
    var classes = useStyles();
    /**
     * Warning: material-ui's page is 0-based
     */
    var range = react_1.useMemo(function () {
        var nbPages = Math.ceil(count / rowsPerPage) || 1;
        if (isNaN(page) || nbPages === 1) {
            return [];
        }
        var input = [];
        // display page links around the current page
        if (page > 1) {
            input.push(1);
        }
        if (page === 3) {
            input.push(2);
        }
        if (page > 3) {
            input.push(".");
        }
        if (page > 0) {
            input.push(page);
        }
        input.push(page + 1);
        if (page < nbPages - 1) {
            input.push(page + 2);
        }
        if (page === nbPages - 4) {
            input.push(nbPages - 1);
        }
        if (page < nbPages - 4) {
            input.push(".");
        }
        if (page < nbPages - 2) {
            input.push(nbPages);
        }
        if (!showEndPages && page < nbPages - 4 && input.includes('.')) {
            return input.slice(0, input.lastIndexOf('.') + 1);
        }
        return input;
    }, [page, rowsPerPage, count]);
    var nbPages = react_1.useMemo(function () { return Math.ceil(count / rowsPerPage) || 1; }, [
        count,
        rowsPerPage,
    ]);
    var prevPage = react_1.useCallback(function (event) {
        if (page === 0) {
            throw new Error("Cannot go before page 1");
        }
        onChangePage(event, page - 1);
    }, [page, onChangePage]);
    var nextPage = react_1.useCallback(function (event) {
        if (page > nbPages - 1) {
            throw new Error("Cannot go after last page");
        }
        onChangePage(event, page + 1);
    }, [page, nbPages, onChangePage]);
    var gotoPage = react_1.useCallback(function (event) {
        var page = parseInt(event.currentTarget.dataset.page, 10);
        if (page < 0 || page > nbPages - 1) {
            throw new Error("Page number " + (page + 1) + " out of boundaries");
        }
        onChangePage(event, page);
    }, [page, nbPages, onChangePage]);
    var renderPageNums = function () {
        return range.map(function (pageNum, index) {
            return pageNum === "." ? (react_1.default.createElement("span", { key: "hyphen_" + index, className: classes.hellip }, "\u2026")) : (react_1.default.createElement(Button_1.default, { className: "page-number", color: pageNum === page + 1 ? "default" : "primary", key: pageNum, "data-page": pageNum - 1, onClick: gotoPage, size: "small" },
                react_1.default.createElement("span", { className: classes.offScreen }, "Page "),
                pageNum));
        });
    };
    if (nbPages === 1) {
        return react_1.default.createElement("div", { className: classes.actions });
    }
    return (react_1.default.createElement("div", { className: classes.actions },
        page > 0 && (react_1.default.createElement(Button_1.default, { color: "primary", key: "prev", onClick: prevPage, className: "previous-page", size: "small" },
            react_1.default.createElement(ChevronLeft_1.default, null),
            "Prev")),
        renderPageNums(),
        page !== nbPages - 1 && (react_1.default.createElement(Button_1.default, { color: "primary", key: "next", onClick: nextPage, className: "next-page", size: "small" },
            "Next",
            react_1.default.createElement(ChevronRight_1.default, null)))));
};
exports.default = exports.PaginationActions;
//# sourceMappingURL=Actions.js.map